import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

import Navbar from "../global-components/navbar-v4";
import PageHeader from "../global-components/page-header";

import CallToActionV1 from "../section-components/call-to-action-v1";
import SponsorV2 from "../section-components/sponsor-v2";
import Footer from "../global-components/footer";

class BlockManagement extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
      <div>
        <Navbar />
        <PageHeader headertitle="Block Management" />

        <div className="ltn__page-details-area ltn__service-details-area mb-105">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="ltn__page-details-inner ltn__service-details-inner">
                  <div className="ltn__blog-grid-img">
                    <img
                      src={publicUrl + "assets/img/service/block-1.jpg"}
                      alt="Block management"
                    />
                  </div>
                  <p>
                    {" "}
                    <span className="ltn__first-letter">B</span>lock management is the
                    day-to-day running of a block of flats or a mixed-use building on
                    behalf of the people who own it. Quoin Management works for
                    leaseholders, residents' management companies (RMCs), right to
                    manage (RTM) companies and freeholders, looking after the shared
                    parts of the building and the money that pays for them.
                  </p>
                  <p>Our block management service covers:</p>
                  <ul>
                    <li>
                      <strong>Service charges and accounts:</strong> preparing the annual budget, issuing service charge demands, collecting service charges and ground rent, and producing clear year-end accounts. Leaseholders can see how their money has been spent, with each cost set out against the budget. Our accounts follow the RICS Service Charge Residential Management Code.
                    </li>
                    <li>
                      <strong>Reserve fund planning:</strong> planning ahead for major costs such as roof, lift or decoration works, so the building builds up a reserve fund rather than facing large one-off bills. We review the plan each year as part of the budget, so contributions stay steady and predictable.
                    </li>
                    <li>
                      <strong>Major works and Section 20:</strong> running the Section 20 consultation with leaseholders for major works and long-term contracts, obtaining quotes and managing the works through to completion. Leaseholders are kept informed at every stage, and following the process correctly protects the building's right to recover the full cost through the service charge.
                    </li>
                    <li>
                      <strong>Buildings insurance:</strong> arranging insurance for the block and handling claims. We review the cover at each renewal so the building stays properly insured for the cost of rebuilding it.
                    </li>
                    <li>
                      <strong>Fire and building safety:</strong> arranging fire risk assessments, acting on their findings, and helping the building meet its duties under the Building Safety Act 2022. We keep a clear record of every assessment and the action taken, so directors and freeholders can show the building is being managed safely.
                    </li>
                    <li>
                      <strong>Health and safety in shared areas:</strong> lift servicing and inspections, legionella risk assessments, asbestos surveys and electrical checks for the communal parts. Each check is booked on a schedule and recorded, so nothing is missed and the paperwork is ready if it is ever needed.
                    </li>
                    <li>
                      <strong>Day-to-day upkeep:</strong> managing cleaning, gardening, communal lighting and repairs, and the contractors who carry them out. We visit the building quarterly to check the standard of work and spot problems early.
                    </li>
                    <li>
                      <strong>On-site caretakers:</strong> providing caretakers for buildings that need someone on site. They keep an eye on the shared areas and are a familiar point of contact for residents.
                    </li>
                    <li>
                      <strong>Lease enforcement:</strong> dealing with breaches of the lease, such as noise, pets or unauthorised subletting, fairly and in line with the lease. We aim to resolve problems informally first, and only take formal action when it is needed.
                    </li>
                    <li>
                      <strong>Lease advice:</strong> answering leaseholders' questions and explaining what the lease says about repairs, alterations and charges. When a question needs a formal legal view, we work with a solicitor.
                    </li>
                    <li>
                      <strong>Selling a flat:</strong> providing the leasehold management pack that a buyer's solicitor needs when a flat is sold. It sets out the service charges, any planned works and the building's insurance, so the buyer knows what they are taking on.
                    </li>
                    <li>
                      <strong>Support for directors:</strong> helping RMC and RTM company directors with AGMs, meetings and company secretarial work. We take care of the paperwork and company filings, so directors can focus on the decisions that matter for their building.
                    </li>
                    <li>
                      <strong>Right to Manage and enfranchisement:</strong> helping leaseholders through the Right to Manage process or a collective purchase of the freehold. We guide the group through each step and can take on the management of the building once the change is complete.
                    </li>
                    <li>
                      <strong>Client money:</strong> holding service charge money in a protected client account, kept separate from our own funds. As a member of Client Money Protect, the money we hold on your behalf is protected if anything goes wrong.
                    </li>
                  </ul>
                  <div className="row">
                    <div className="col-lg-6">
                      <img
                        src={publicUrl + "assets/img/service/block-2.jpg"}
                        alt="Block management"
                      />
                      {/* <label>Image caption here.</label> */}
                    </div>
                    <div className="col-lg-6">
                      <img
                        src={publicUrl + "assets/img/service/block-3.jpg"}
                        alt="Block management"
                      />
                    </div>
                  </div>
                  <p>
                    <strong>Everything in one app.</strong> Leaseholders and directors
                    can use the Quoin Management app to pay service charges, view
                    documents such as budgets and accounts, report repairs and receive
                    announcements about their building, all in one place.
                  </p>
                  <p>
                    Whether you are a leaseholder, a director of a residents'
                    management company or a freeholder, we would be happy to talk
                    about how we can look after your building.{" "}
                    <Link to="/contact">Get in touch</Link>.
                  </p>
                </div>
              </div>
              <div className="col-lg-4">
                <aside className="sidebar-area ltn__right-sidebar">
                  {/* Menu Widget */}
                  <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                    <ul className="go-top">
                      <li>
                        <Link to="/property-management">
                          Property Management{" "}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/residential-management">
                          Residential Management{" "}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/commercial-management">
                          Commercial Management{" "}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/compliance-management">
                          Compliance Management{" "}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/legal">
                          Legal{" "}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/emergency-response">
                          Emergency Response{" "}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/refurbishment">
                          Refurbishment{" "}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                      <li className="active">
                        <Link to="/block-management">
                          Block Management{" "}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                  {/* Newsletter Widget */}
                  <div className="widget ltn__search-widget ltn__newsletter-widget">
                    <h6 className="ltn__widget-sub-title">Subscribe</h6>
                    <h4 className="ltn__widget-title">Get Newsletter</h4>
                    <form action="#">
                      <input type="text" name="search" placeholder="Search" />
                      <button type="submit">
                        <i className="fas fa-search" />
                      </button>
                    </form>
                    <div className="ltn__newsletter-bg-icon">
                      <i className="fas fa-envelope-open-text" />
                    </div>
                  </div>
                  {/* Banner Widget */}
                  {/* <div className="widget ltn__banner-widget go-top">
                    <Link to="/shop">
                      <img
                        src={publicUrl + "assets/img/banner/banner-1.jpg"}
                        alt="Banner Image"
                      />
                    </Link>
                  </div> */}
                </aside>
              </div>
            </div>
          </div>
        </div>
        <SponsorV2 />
        <CallToActionV1 />
        <Footer />
      </div>
    );
  }
}

export default BlockManagement;
